const isProd = process.env.VERCEL_ENV === 'production';

const reviewsAppUrl = process.env.NEXT_PUBLIC_REVIEWS_APP_URL || 'https://app.localprof.com';
const docAppUrl = process.env.NEXT_PUBLIC_DOC_APP_URL || 'https://doc.localprof.com';

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || 'https://localprof.com';

const apiUrl = isProd
  ? process.env.NEXT_PUBLIC_API_URL
  : process.env.NEXT_PUBLIC_API_URL || 'https://devapi.localprof.com';

const countryCode = process.env.NEXT_PUBLIC_COUNTRY_CODE || 'US';

if (!apiUrl) {
  throw new Error('NEXT_PUBLIC_API_URL is not defined');
}

const config = {
  countryCode,
  isProd,
  apiUrl,
  reviewsAppUrl,
  baseUrl,
  docAppUrl,
  gtmId: process.env.NEXT_PUBLIC_GTM_ID,
  pixelId: process.env.NEXT_PUBLIC_PIXEL_ID,
  defaultLocale: process.env.defaultLocale || 'en',
} as const;

export default config;
